import createInstance from '../util'
import { BaseGridStrategyParam } from './index'
import { BaseResponse } from 'api/common'
import { RunAndPauseMap } from 'constants/strategy'
let commonInstance = createInstance('/v1/trigger/strategy/portfolio')
let commonInstance2 = createInstance('/v1/strategyPlatform/public')
/**
 * 币对配置
 * @param params
 * @returns
 */
export function getPortfolioConfig(params): Promise<any> {
    return createInstance('/v1/trigger/strategy').post('/config/portfolio', params)
}

interface createHoardStrategyRequestParams {
    name: string
    balanceType: number
    timeType: number
    timeValue: number
    balanceRate: number
    investAmount: string
    useAccountAssets: string
    endOperate: string
}

/**
 * 囤币宝创建策略
 * @param params
 * @returns
 */
export function placeStrategyPortfolio(params: createHoardStrategyRequestParams) {
    return commonInstance.post('/placeStrategyPortfolio', params)
}

/**
 * 创建确认
 * @param params
 * @returns
 */
export function confirmParam(params) {
    return commonInstance.post('/confirmParam', params)
}

/**
 * 终止确认
 * @param params
 * @returns
 */
// export function cancelStrategyConfirm(params) {
//     return commonInstance1.post('/cancelStrategyConfirm', params)
// }

/**
 * 终止策略
 * @param params
 * @returns
 */
export function cancelStrategy(params) {
    return commonInstance.post('/cancel', params)
}

/**
 * 最小投资额
 * @param params
 * @returns
 */
export function queryMinInvestAmount(params) {
    return commonInstance.post('/queryMinInvestAmount', params)
}

/**
 * 投资详情
 * @param params
 * @returns
 */
export function getInvestDetail(params): Promise<any> {
    return commonInstance.post('/investDetail', params)
}
/**
 * 修改策略
 * @param params
 * @returns
 */
export function updateStrategyHoard(params) {
    return commonInstance.post('/update', params)
}

/**
 * 仓位详情
 * @param params
 * @returns
 */
export function getHoardPostionList(params) {
    return commonInstance.post('/strategyPositionInfo', params)
}

/**
 * 已完成-已废弃
 * @param params
 * @returns
 */
export function getHoardOldCompletedList(params) {
    return commonInstance.post('/strategyOrderList', params)
}
export function getHoardCompletedList(params) {
    return commonInstance.post('/strategyEventList', params)
}
/**
 * 策略详情
 * @param params
 * @returns
 */
export function getHoardStrategyInfoList(params) {
    return commonInstance.post('/strategyInfo', params)
}

/**
 * 获取囤币宝AI列表
 * https://yapi.sniper5.vip/project/53/interface/api/70656
 */
export function getHoardAiList(params) {
    return commonInstance2.post('/portfolioList', params)
}
/**
 * 获取囤币宝AI详情
 * https://yapi.sniper5.vip/project/53/interface/api/70655
 */
export function getHoardAiDetail(params) {
    return commonInstance2.post<any>('/portfolioConfig', params)
}

/**
 * 暂停、运行
 * https://yapi.sniper5.vip/project/44/interface/api/98712
 * @param params 
 * @returns 
 */
export function editHordStatus(params: { strategyId: string, runningStatus: number }) {
    return commonInstance.post<BaseResponse<any>>('/pause', params)
}

interface UpdateBalanceTypeRequestParams {
    strategyId: string,
    balanceType?: string | number,
    timeType?: string | number,
    timeValue?: string,
    balanceRate?: string
}
/**
 * 平衡模式编辑
 * https://yapi.sniper5.vip/project/44/interface/api/98724
 * @param params 
 * @returns 
 */
export function updateBalanceType(params: UpdateBalanceTypeRequestParams) {
    return commonInstance.post<BaseResponse<any>>('/updateBalanceType', params)
}


interface investConfig {
    symbolId: string,
    ratio: string
}
/**
 * 币种编辑
 * https://yapi.sniper5.vip/project/44/interface/api/98730
 * @param params 
 * @returns 
 */
export function editTokenConfig(params: { strategyId: string, investConfig: Array<investConfig> }) {
    return commonInstance.post<BaseResponse<any>>('/editTokenConfig', params)
}

/**
 * 获取编辑币种最小投资额
 * https://yapi.sniper5.vip/project/44/interface/api/98718
 * @param params 
 * @returns 
 */
export function getEditTokenInvestAmount(params: { strategyId: string, investConfig: Array<investConfig> }) {
    return commonInstance.post<BaseResponse<any>>('/getEditTokenInvestAmount', params)
}
